module.exports = __webpack_public_path__ + "images/commercial-floorplan-5bfb11f87aacc02dc00e8df48c5527a8.svg";